import React from 'react';
import Emptylustration from './../../../../assets/images/svg/047-ticket.svg';

export const EmptyState = () => {
    return (
        <section className="col flex-column align-items-center justify-content-center py-sm-5 h-xl-inherit">
            <img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
            <div className="block text-center container-thin mx-auto">
                <h1 className="font-weight-bolder ls-n1 lh-1">Aucune facture trouvée!</h1>
                <p className="o-80 mb-0">Lorsque vous êtes prêt, affichez et gérez les modes de paiement pour profiter d'Assist@.</p>
            </div>
        </section>
    )
}